// Styles
import '../styles/app.scss';

// Components
import Navigation from 'Components/Navigation';
import Hero from 'Components/Hero';
import Card from 'Components/Card';
import ReachOut from 'Components/ReachOut';
import Stats from 'Components/Stats';
import Showcase from 'Components/Showcase';
import Video from 'Components/Video';
//import CookieBanner from 'Components/CookieBanner';
import Rail from 'Components/Rail';
import HubFilter from 'Components/HubFilter';
import PropertyNoImage from 'Components/PropertyNoImage';
import Download from 'Components/Download';
import Wysiwyg from 'Components/Wysiwyg';
import Form from 'Components/Form';
import Floodlight from 'Components/Floodlight';
import IconModule from 'Components/IconModule';
import GridModule from 'Components/GridModule';
import InlineGallery from 'Components/InlineGallery';
import Search from 'Components/Search';
import ProgramGrid from 'Components/ProgramGrid';
import ScreenerVideoEmbed from 'Components/ScreenerVideoEmbed';
import EventListing from 'Components/EventListing';
//import Bookmark from 'Components/Bookmark';
import SavedContents from 'Components/SavedContents';
import DownloadReport from 'Components/DownloadReport';
import CountdownClock from 'Components/CountdownClock';
import CountdownClockHero from 'Components/CountdownClockHero';
import CountdownClockLandingBody from 'Components/CountdownClockLandingBody';
import CountdownClockDetailBody from 'Components/CountdownClockDetailBody';
import InterstitialPopup from 'Components/InterstitialPopup';
import AnchorLink from 'Components/AnchorLink';
import Profile from 'Components/Profile';
import DashboardControl from 'Components/DashboardControl';
import Embeds from 'Components/Embeds';
import InternalHubMenu from './components/InternalHubMenu';

// Helpers
import { setBreakpoint } from 'Helpers/breakpoints';

// [MD] Add a map for each component class (non singletons)
const classes = new Map(
  [
    ['Navigation', Navigation],
    ['Hero', Hero],
    ['Card', Card],
    ['ReachOut', ReachOut],
    ['Stats', Stats],
    ['Showcase', Showcase],
    ['Video', Video],
    ['Rail', Rail],
    ['HubFilter', HubFilter],
    ['PropertyNoImage', PropertyNoImage],
    ['Download', Download],
    ['Wysiwyg', Wysiwyg],
    ['Form', Form],
    ['Floodlight', Floodlight],
    ['IconModule', IconModule],
    ['GridModule', GridModule],
    ['InlineGallery', InlineGallery],
    ['Search', Search],
    ['ProgramGrid', ProgramGrid],
    ['ScreenerVideoEmbed', ScreenerVideoEmbed],
    ['EventListing', EventListing],
    //['Bookmark', Bookmark],
    ['SavedContents', SavedContents],
    ['DownloadReport', DownloadReport],
    ['CountdownClock', CountdownClock],
    ['CountdownClockHero', CountdownClockHero],
    ['CountdownClockLandingBody', CountdownClockLandingBody],
    ['CountdownClockDetailBody', CountdownClockDetailBody],
    ['AnchorLink', AnchorLink],
    ['Profile', Profile],
    ['DashboardControl', DashboardControl],
    ['Embeds', Embeds],
    ['InternalHubMenu', InternalHubMenu],
  ]
);

// Initialize Components
document.addEventListener(
  'DOMContentLoaded', () => {
    let timeout = null;

    // Set current breakpoint
    setBreakpoint();

    if (window.location !== window.parent.location) {
      if (document.getElementById('wpadminbar')) {
        document.getElementById('wpadminbar').setAttribute('style', 'display:  none');
      }

      document.querySelector('html').setAttribute('style', 'margin-top: 0 !important');

      if (document.querySelector('.wt-preview-bar')) {
        document.querySelector('.wt-preview-bar').setAttribute('style', 'display:  none');
      }
    }

    // Interstitial Popup
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => InterstitialPopup(), 3000);

    // All components
    classes.forEach(Module => new Module());

    //CookieBanner();
  }
);

// Let the document know when the mouse is being used
document.addEventListener(
  'mousedown', e => {
    handleMouseDownOnce(e);
  }
);

document.addEventListener(
  'keydown', e => {
    // Toggle Grid Guide
    // Press CTRL + G to toggle
    if (e.ctrlKey && e.keyCode === 71) {
      document.documentElement.classList.toggle('show-grid');
    }

    handleFirstTab(e);
  }
);

function handleFirstTab(e) {
  if (e.keyCode === 9) { // the "I am a keyboard user" key
    document.body.classList.remove('using-mouse');
    document.body.classList.add('user-is-tabbing');

    document.removeEventListener('keydown', handleFirstTab);
    document.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.add('using-mouse');
  document.body.classList.remove('user-is-tabbing');

  document.removeEventListener('mousedown', handleMouseDownOnce);
  document.addEventListener('keydown', handleFirstTab);
}

function setVariables() {
    var new_heading_text_height = 0;
	jQuery('.dropdown__content--column .heading-text').css('height', '');
    jQuery('.dropdown__content--column').find('.heading-text').each(function(index) {
        var heading_text_height = jQuery(this).height();
        if(heading_text_height > new_heading_text_height) {
            new_heading_text_height = heading_text_height;
        }
    });

    var nav_height = jQuery('.main-navigation__container-wrap').height();
    var sec_nav_height = jQuery('.secondary-navigation').height();
    var dropdown_header_height = jQuery('.dropdown-navigation__single.is-active').find('.dropdown__header').height();
    var header_height = nav_height + sec_nav_height;
    var menu_height_adjust = nav_height + sec_nav_height + dropdown_header_height;
    document.documentElement.style.setProperty('--header-height', header_height + 'px');
    document.documentElement.style.setProperty('--heading-text-height', new_heading_text_height + 'px');
    document.documentElement.style.setProperty('--menu-height-adjust', menu_height_adjust + 'px');
}

function renderMenus() {
    var new_heading_text_height = 0;

	jQuery('.dropdown__content--column .heading-text').css('height', '');
    jQuery('.dropdown__content--column').find('.heading-text').each(function(index) {
        var heading_text_height = jQuery(this).height();
        if(heading_text_height > new_heading_text_height) {
            new_heading_text_height = heading_text_height;
        }
    });

    jQuery('.dropdown__content--column').find('.heading-text').each(function(index) {
        jQuery(this).css('height', new_heading_text_height + 'px');
    });

    jQuery('.dropdown__content--column-links').each(function(index) {
        var col_span = jQuery(this).data('column-span');
        var sub_col_items = jQuery(this).data('sub-column-items');
        var link_count = jQuery(this).data('link-count');

        if(col_span === 1) {
            var link_height = 100 / link_count;
            jQuery(this).find('.column-link').each(function(index) {
                jQuery(this).css('flex-basis', link_height + '%');
                jQuery(this).css('max-height', link_height + '%');
            });
        } else {
            if(sub_col_items === 'all') {
                var link_height = 100 / link_count;
                jQuery(this).find('.column-link').each(function(index) {
                    jQuery(this).css('flex-basis', link_height + '%');
                    jQuery(this).css('max-height', link_height + '%');
                });
            } else {
                if(link_count > sub_col_items) {
                    var even_check = link_count % sub_col_items;

                    if(even_check === 0) {
                        var col_count = link_count / sub_col_items;
                        var col_width = 100 / col_count;
                        var link_height = 100 / sub_col_items;
                        jQuery(this).find('.column-link').each(function(index) {
                            jQuery(this).css('flex-basis', link_height + '%');
                            jQuery(this).css('max-height', link_height + '%');
                            jQuery(this).css('width', col_width + '%');
                        });
                    } else {
                        var even_count = Math.floor(link_count / sub_col_items);
                        var col_count = even_count + 1;
                        var col_width = 100 / col_count;

                        var even_items = sub_col_items * even_count;
                        var uneven_items = link_count - even_items;

                        var link_even_height = 100 / sub_col_items;
                        var link_uneven_height = 100 / uneven_items;

                        jQuery(this).find('.column-link').each(function(index) {
                            if(index >= even_items) {
                                jQuery(this).css('flex-basis', link_uneven_height + '%');
                                jQuery(this).css('max-height', link_uneven_height + '%');
                                jQuery(this).css('width', col_width + '%');
                            } else {
                                jQuery(this).css('flex-basis', link_even_height + '%');
                                jQuery(this).css('max-height', link_even_height + '%');
                                jQuery(this).css('width', col_width + '%');
                            }

                        });
                    }
                } else {
                    var link_height = 100 / sub_col_items;
                    jQuery(this).find('.column-link').each(function(index) {
                        jQuery(this).css('flex-basis', link_height + '%');
                        jQuery(this).css('max-height', link_height + '%');
                    });
                }
            }
        }
    });
}

jQuery(document).ready(function() {

	setVariables();

	jQuery('.main-nav-link').click(function() {
		var dropdown_id = jQuery(this).data('dropdown');
		jQuery('.dropdown-navigation__single').hide();
		jQuery('.dropdown-navigation__single').removeClass('is-active');
		jQuery('.main-nav-link').removeClass('is-active');
		jQuery(this).addClass('is-active');
		jQuery('#dropdown--' + dropdown_id).show();
		jQuery('#dropdown--' + dropdown_id).addClass('is-active');
		jQuery('#dropdown--' + dropdown_id).find('.dropdown__header a').focus();
		jQuery('.main-navigation').addClass('navigation-open');
		setVariables();
		renderMenus();
	});

    jQuery('.close-dropdown').click(function() {
        jQuery('.main-nav-link.is-active').find('.dropdown__header a').focus();
        jQuery('.dropdown-navigation__single').hide();
        jQuery('.dropdown-navigation__single').removeClass('is-active');
        jQuery('.main-nav-link').removeClass('is-active');
        jQuery('.main-navigation').removeClass('navigation-open');
    });

    jQuery('.open-submenu').click(function() {
        var submenu_id = jQuery(this).data('submenu');
        jQuery('#submenu--' + submenu_id).toggleClass('submenu-closed');
    });

	jQuery('.play-button-embed').click(function() {
		jQuery(this).closest('.video__overlay').hide();
		jQuery(this).parents().find('.video__content').hide();
	});

	jQuery(function() {
		jQuery('.js-video-modal').on('click', function() {
			setTimeout(function() {
				jQuery('.template-modal').each(function(index) {
					jQuery(this).find('.video-modal__image-container').css('max-height', 'none');
					jQuery(this).find('.video-modal__image-container').css('flex-basis', 'auto');
					var template_content_height = jQuery(this).find('.video-modal__content-container--copy').height();
					var template_container_height = jQuery(this).find('.video-modal__content-container').height();
					var template_orig_image_height = jQuery(this).find('.video-modal__image-container img').height();
					var template_image_height = template_container_height - (template_content_height + 24);
					if(template_orig_image_height > template_image_height) {
						jQuery(this).find('.video-modal__image-container').css('max-height', template_image_height + 'px');
						jQuery(this).find('.video-modal__image-container').css('flex-basis', template_image_height + 'px');
					} else {
						jQuery(this).find('.video-modal__image-container').css('max-height', 'none');
						jQuery(this).find('.video-modal__image-container').css('flex-basis', 'auto');
					}
				});
			},1000);

			var video_modal = jQuery(this).data('video-modal-id');
			if(jQuery(this).hasClass('selected')) {
				jQuery(this).removeClass('selected');
				jQuery('#' + video_modal).removeClass('is-visible');
			} else {
				jQuery(this).addClass('selected');
				jQuery('#' + video_modal).addClass('is-visible');
			}
			return false;
		});

		jQuery('.js-video-modal-close').on('click', function() {
			jQuery('.js-video-modal').removeClass('selected');
			jQuery(this).parents('.video-modal').removeClass('is-visible');
			jQuery(this).parent().find('iframe').attr('src',jQuery(this).parent().find('iframe').attr('src'));
			jQuery(this).parents().find('video').trigger('pause');
			return false;
		});
	});
  
  async function checkElementLocationSequentially() {
    const elements = jQuery('.to-fade-in').toArray();

    for (const el of elements) {
    const $el = jQuery(el);
    const top_of_element = $el.offset().top;
    const bottom_of_element = top_of_element + $el.outerHeight();
    const bottom_of_screen = jQuery(window).scrollTop() + jQuery(window).innerHeight();
    const top_of_screen = jQuery(window).scrollTop();

    const isInView = (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
    const alreadyFaded = $el.hasClass('fade-in');

    if (isInView && !alreadyFaded) {
      await fadeInElement($el);
    }
    }
  }

  function fadeInElement($el) {
    return new Promise((resolve) => {
    setTimeout(() => {
      $el.addClass('fade-in'); // 600ms fade duration
      resolve();
    }, 500);
    });
  }

  // Initial check
  checkElementLocationSequentially();

  // On scroll
  jQuery(window).on('scroll', function () {
    checkElementLocationSequentially();
  });
});
